module.exports = __webpack_public_path__ + "static/media/autoPay.4bbaaec5.svg";